import { render, staticRenderFns } from "./AthleteRecruitingProfileVideosView.vue?vue&type=template&id=3521ffb0&"
import script from "./AthleteRecruitingProfileVideosView.vue?vue&type=script&lang=ts&"
export * from "./AthleteRecruitingProfileVideosView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports